export default {
  subject: 'subject',
  email: 'e-mail',
  name: 'name',
  message: 'message',
  password: 'password',
  repeatPassword: 'repeat password',
  username: 'username',
  country: 'country',
  console: 'console',
  position: 'position',
  newPassword: 'new password',
  passwordConfirmation: 'confirm new password',
  title: 'title',
  idOrUsername: 'id or username',
  period: 'period',
  description: 'description',
  videoCode: 'video code',
  order: 'order',
  type: 'type',
  teamDowns: 'Number of teams that are down',
  teamLiguilla: 'Number of teams passing wing liguilla',
  cardNumber: 'card number',
  expirationDate: 'expiration date',
  cardMonth: 'month',
  cardYear: 'year',
}
